export const adItems = [
  { type: 'marquee', textKey: 'ad_marquee_limo' },
  { type: 'image', src: '/ads/x1.jpeg' },
  { type: 'marquee', textKey: 'ad_marquee_revolution' },
  { type: 'image', src: '/ads/x2.jpg' },
  { type: 'marquee', textKey: 'ad_marquee_partners' },
  { type: 'image', src: '/ads/x3.jpg' },
  { type: 'marquee', textKey: 'ad_marquee_copyright' },
  { type: 'image', src: '/ads/x4.jpeg' },
];
